export default "__VITE_ASSET__bf7c177c__"